import { useDispatch, useSelector } from 'react-redux';

// These type annotations are specific to TypeScript and are used to provide type safety.
// In JavaScript, you can omit them since the language does not have a type system.

// import { RootState, AppDispatch } from './store';

// Custom hooks for dispatch and selector without TypeScript types
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;